import * as getters from '@/store/modules/transfers/nacional/getters'
import * as mutations from '@/store/modules/transfers/nacional/mutations'
import * as actions from '@/store/modules/transfers/nacional/actions'

const state = {
    accountsBalances: [],
    scheduleTypes: [],
    transfersCategoriesList: [],
    transfersMotivesList: [],
    transfersOperationsList: [],
    transfersList: [],
    smartTransfersList: [],
    favoritesList: [],
    favoritesHasMore: null,
    beneficiariesList: []
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
